import React from 'react';
import { Card, List, Button } from 'antd';
import AntdProForm, {
  ProFormDigit,
  ProFormTextArea,
  ProFormList,
} from '@ant-design/pro-form';
import { DeleteOutlined } from '@ant-design/icons';
import { SelectFundingSource } from '../../../input';
import { WIDTH_2_COL } from '../../../../constants/form';

const deleteButton = ({ ...props }) => (
  <Button {...props} type="link">
    <DeleteOutlined />
    Remove
  </Button>
);

const FundingForm = () => {
  return (
    <Card title="Funding" style={{ marginBottom: '24px' }}>
      <Card type="inner" title="Approved Funding">
        <AntdProForm.Group>
          <SelectFundingSource name={['approvedFunding', 'source']} />
          <ProFormDigit
            label="Funding Amount"
            name={['approvedFunding', 'amount']}
            width="xl"
            min={0}
            fieldProps={{ formatter: (value) => `$ ${value}`, precision: 2 }}
            rules={[
              {
                required: true,
                message: 'Please enter funding amount!',
              },
            ]}
          />
        </AntdProForm.Group>
        <ProFormTextArea
          width={WIDTH_2_COL}
          name={['approvedFunding', 'conditionOfAllocation']}
          label="Condition Of Allocation"
          placeholder="Condition Of Allocation"
        />
      </Card>
      <Card type="inner" title="Additional Funding">
        <div className="ant-list-split">
          <ProFormList
            name="additionalFunding"
            creatorButtonProps={{
              style: {
                width: `${WIDTH_2_COL}px`,
              },
              position: 'bottom',
              creatorButtonText: 'Add Additional Funding',
            }}
            copyIconProps={false}
            deleteIconProps={{
              show: true,
              Icon: deleteButton,
            }}
            itemRender={({ listDom, action }) => {
              return (
                <List.Item
                  extra={action}
                  style={{
                    marginBottom: 8,
                    flexWrap: 'wrap',
                  }}
                >
                  {listDom}
                </List.Item>
              );
            }}
          >
            <AntdProForm.Group>
              <SelectFundingSource name={'source'} />
              <ProFormDigit
                label="Funding Amount"
                name="amount"
                width="xl"
                min={0}
                fieldProps={{
                  formatter: (value) => `$ ${value}`,
                  precision: 2,
                }}
                rules={[
                  {
                    required: true,
                    message: 'Please enter funding amount!',
                  },
                ]}
              />
            </AntdProForm.Group>
            <ProFormTextArea
              width={WIDTH_2_COL}
              name="conditionOfAllocation"
              label="Condition Of Allocation"
              placeholder="Condition Of Allocation"
            />
          </ProFormList>
        </div>
      </Card>
    </Card>
  );
};

export default FundingForm;
